export default __webpack_public_path__ + "static/media/plant-archetypes.c3fa158c.svg";